import React, { forwardRef, Ref } from 'react';

import { findDOMNode } from 'react-dom';
import { Col as AntCol, ColProps as AntColProps } from 'antd/lib/grid';

export type ColProps = AntColProps;

export const ColWithRef = (props: ColProps, fwRef: Ref<Element | Text>) => {
  return (
    <AntCol
      {...props}
      ref={(ref) => {
        if (!(fwRef && typeof fwRef === 'function')) return;
        if (!ref) fwRef(null);

        // eslint-disable-next-line
        const divRef = findDOMNode(ref);
        fwRef(divRef);
      }}
    />
  );
};

export const Col = forwardRef(ColWithRef);
